import {
  formatCurrency,
  membershipHelper,
  ordinal,
  pluralize,
} from "@gymflow/helpers";
import {
  Currency,
  CurrentSubscriptionDTO,
  SubscriptionMembershipPreviousDTO,
} from "@gymflow/types";
import { t } from "i18next";
import moment from "moment";

const DATE_FORMAT = "D MMM, YYYY";

export const getBillingText = (
  currentMembership:
    | CurrentSubscriptionDTO
    | SubscriptionMembershipPreviousDTO
    | undefined,
  defaultCurrency: Currency,
) => {
  if (!currentMembership) {
    return "";
  }

  const price = formatCurrency(currentMembership.price, defaultCurrency);

  if (
    currentMembership.type === "TRIAL" ||
    currentMembership.type === "PREPAID"
  ) {
    return t(
      "pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.billing.onceOff",
      { price },
    );
  }

  const billingPeriod = currentMembership.billingPeriod;
  const billingType = currentMembership.billingType;

  if (!billingPeriod || !billingType) {
    return "";
  }

  const billingDay = membershipHelper.getBillingDay(currentMembership);
  const key = pluralize("singular", "plural", billingPeriod);
  const payload = {
    price,
    billingDay:
      billingType === "MONTHLY" ? ordinal(Number(billingDay)) : billingDay,
    billingPeriod: billingPeriod.toString(),
  };

  return t(
    `pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.billing.${billingType.toLowerCase()}.${key}`,
    payload,
  );
};

export const getMembershipTypeText = (
  currentMembership:
    | CurrentSubscriptionDTO
    | SubscriptionMembershipPreviousDTO
    | undefined,
) => {
  if (!currentMembership) {
    return "";
  }
  if (currentMembership.type === "TRIAL") {
    return t(
      `pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.membershipType.trial`,
    );
  }

  if (!currentMembership.type) {
    return "";
  }

  return t(
    `pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.membershipType.${currentMembership.type.toLowerCase()}`,
  );
};

export const getTillDateText = (
  currentMembership: CurrentSubscriptionDTO | SubscriptionMembershipPreviousDTO,
  timezone?: string,
) => {
  if (!currentMembership || !currentMembership.endContractDate) {
    return "";
  }

  const date = timezone
    ? moment(currentMembership.endContractDate).tz(timezone).format(DATE_FORMAT)
    : moment(currentMembership.endContractDate).format(DATE_FORMAT);

  return t(
    "pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.tillDate",
    { date },
  );
};
